import { component } from "picoapp";
import "slick-carousel";
import $ from "jquery";

export default component((node) => {
  $(".js-cluster-slider").slick({
    dots: false,
    arrows: false,
    draggable: true,
    swipe: true,
  });
});
